export const siteIds = {
  Nissen: 'nissen',
  InstrumentariumFI: 'instrumentarium',
  Keops: 'keops',
  InstrumentariumEE: 'instrumentarium-ee',
  Terveystalo: 'terveystalo',
};
